<template>
    <div>
        <content-view v-show="$utils.renderWhen(this, 'platformSell')">
            <div slot="header">
                <a-form :form="form" layout="inline" class="store-one-form">
                    <a-form-item label="优惠名称">
                        <a-input placeholder="请输入" v-decorator="['name']" @pressEnter="getList"></a-input>
                    </a-form-item>
                    <a-form-item class="wrap-header-button">
                        <a-button @click="getList" class="mr8" type="primary">筛选</a-button>
                        <a-button @click="handleReset">重置</a-button>
                    </a-form-item>
                </a-form>
            </div>
            <div class="platform-sell" v-if="shopId != -1">
                <a-spin :spinning="spinning">
                    <a-tabs
                    type="card"
                    :tabBarStyle="{marginBottom: 0}"
                    :activeKey="tabKey"
                    @change="outTabsChange"
                    >
                        <a-tab-pane v-for="tab in tabList" :key="tab.key" :tab="tab.name">
                            <a-card
                            class="card-box"
                            :bordered="false"
                            :tabList="tabListNoTitle"
                            :activeTabKey="noTitleKey"
                            @tabChange="key => onTabChange(key,'noTitleKey')"
                            >
                                <div class="mt8" slot="tabBarExtraContent" v-if="getBtnByAuth('addTicketDiscount')">
                                    <a-button type="primary" @click="toAddSell('add'+tab.routeName, tab.key)">新增{{tab.name}}优惠</a-button>
                                </div>
                                <div class="card-list">
                                    <a-card v-for="(item,index) in dataSource" :key="index">
                                        <a-row class="mb8">
                                            <a-col :span="9">{{['','打折','满减'][item.discountType]}}优惠名称：</a-col>
                                            <a-col :span="15" class="text-name">
                                                <a-tooltip :title="item.name">{{item.name}}</a-tooltip>
                                            </a-col>
                                        </a-row>
                                        <a-row class="mb8" v-if="item.discountType === 1">
                                            <a-col :span="9">打折百分比%：</a-col>
                                            <a-col :span="15">{{item.discountPercent}}%</a-col>
                                        </a-row>
                                        <a-row class="mb8" v-else>
                                            <a-col :span="9">满减金额详情：</a-col>
                                            <a-col :span="15">{{item.satisfy === 1 ? ('满' + item.satisfyAmount) : '无门槛'}}减{{item.reduceAmount}}</a-col>
                                        </a-row>
                                        <a-row class="mb8">
                                            <a-col :span="9">{{['','打折','满减'][item.discountType]}}{{['','票券','商品'][item.discountTarget]}}范围：</a-col>
                                            <a-col :span="15">{{['','全部','部分'][item.discountRange]}}</a-col>
                                        </a-row>
                                        <a-row class="mb8">
                                            <a-col :span="9">折扣时间范围：</a-col>
                                            <a-col :span="15">{{item.shelveStartDate}}-{{item.shelveEndDate}}</a-col>
                                        </a-row>
                                        <a-tag :color="item.shelve === 1 ? 'green' : 'red'">{{item.shelve === 1 ? '已上架' : '已下架'}}</a-tag>
                                        <template slot="actions" class="ant-card-actions">
                                            <a v-if="getBtnByAuth('detailTicketDiscount')" class="text-primary" @click="toAddSell('detail'+tab.routeName, tab.key, item.id)">详情</a>
                                            <span v-if="getBtnByAuth('editTicketDiscount')">
                                                <a v-if="item.shelve === 1" class="text-disabled">编辑</a>
                                                <a v-else class="text-primary" @click="toAddSell('edit'+tab.routeName, tab.key, item.id)">编辑</a>
                                            </span>
                                            <template v-if="getBtnByAuth('atateTicketDiscount')">
                                                <!-- <span class="text-disabled" v-if="item.shelve === 0">{{item.shelve === 1 ? '下架' : '上架'}}</span> -->
                                                <a-popconfirm
                                                :title="'确定' + (item.shelve === 1 ? '下架' : '上架') + '该优惠吗?'"
                                                @confirm="stateDiscount(item.id, item.shelve)"
                                                >
                                                    <a class="text-primary">{{item.shelve === 1 ? '下架' : '上架'}}</a>
                                                </a-popconfirm>
                                            </template>
                                            <span v-if="getBtnByAuth('deleteTicketDiscount')">
                                                <a v-if="item.shelve === 1" class="text-disabled">删除</a>
                                                <a-popconfirm
                                                v-else
                                                title="确定删除该优惠吗?"
                                                @confirm="deleteDiscount(item.id)"
                                                >
                                                    <a class="text-primary">删除</a>
                                                </a-popconfirm>
                                            </span>
                                        </template>
                                    </a-card>
                                </div>
                                <div v-if="dataSource.length === 0" class="mb16">
                                    <a-empty />
                                </div>
                            </a-card>
                        </a-tab-pane>
                    </a-tabs>
                </a-spin>
            </div>
            <a-empty class="pt24 pb24" v-else >
                <span slot="description" class="font-big22">请切换到各门店查看</span>
            </a-empty>
        </content-view>
        <router-view></router-view>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    const tabListNoTitle = [
        {
            key: '1',
            tab: '打折优惠'
        },
        {
            key: '2',
            tab: '满减优惠'
        }
    ]
    export default {
        name: 'platformSell',
        data() {
            return {
                dataSource: [],
                tabListNoTitle,
                tabKey: 1,
                noTitleKey: '1',
                tabList: [
                    {name: '票券', key: 1, routeName: 'Sell'},
                    {name: '零售', key: 2, routeName: 'Retail'},
                ],
                spinning: false
            }
        },
        computed: {
            ...mapGetters(["shopId"])
        },
        beforeCreate() {
            this.form = this.$form.createForm(this);
        },
        mounted() {
            this.getList();
        },
        watch: {
            shopId() {
                this.getList()
            },
            $route(val, oval) {
                if (val.name === 'platformSell') {
                    this.getList();
                };
            }
        },
        methods: {
            handleReset() {
                this.form.resetFields();
                this.getList();
            },
            getList() {
                if(!this.shopId || this.spinning) {
                    return false;
                }
                this.spinning = true;
                this.form.validateFields((err, values) => {
                    if (!err) {
                        this.$api.changeCode.discountList({
                            body: Object.assign(values,
                            {
                                pageNum: 1,
                                pageSize: 999999,
                                shopId: this.shopId,
                                discountTarget: this.tabKey * 1,
                                discountType: this.noTitleKey * 1,
                            })
                        }).then(res => {
                            this.dataSource = res.list;
                            this.spinning = false;
                        }).catch(err => {
                            this.spinning = false;
                        })
                    }
                });
            },
            outTabsChange(key) {
                this.tabKey = key;
                this.getList();
            },
            onTabChange(noTitleKey,keyName) {
                this[keyName] = noTitleKey;
                this.noTitleKey = noTitleKey;
                this.getList();
            },
            toAddSell(name, discountTarget, id = undefined) {
                if (name.indexOf("add") > -1 && this.shopId == -1) {
                    this.$message.warn("请先切换门店！");
                    return;
                }
                this.$router.push({name: name, query: {discountTarget: discountTarget, id: id}})
            },
            stateDiscount(discountId, shelve) {
                this.$api.changeCode.stateDiscount({
                    params: {
                        discountId: discountId,
                        shelve: shelve === 1 ? 0 : 1
                    }
                }).then(res => {
                    this.$message.success('操作成功');
                    this.getList()
                })
            },
            deleteDiscount(id) {
                this.$api.changeCode.deleteDiscount({
                    params: {
                        id: id
                    }
                }).then(res => {
                    this.$message.success('操作成功');
                    this.getList()
                })
            },
        }
    }
</script>

<style lang="scss">
.platform-sell {
    .card-box {
        .ant-card-body {
            padding-right: 8px;
            padding-bottom: 0;
        }
    }
    .card-list {
        display: flex;
        flex-wrap: wrap;
        .ant-card {
            width: 315px;
            margin-bottom: 24px;
            margin-right: 24px;
            .ant-card-body {
                padding: 16px;
            }
        }
    }
    .text-name {
        text-overflow : ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }
}
</style>
